export const TelefonoRegex = RegExp(/^[0-9]{0,9}$/)
export const CelularRegex = RegExp(/^((\+[0-9]{2}\s)?[0-9]{3}[\s\-]?[0-9]{3}\s?[0-9]{3,4})?$/)
export const UltimaSalidaRegex = RegExp(/^[0-9]{0,6}.[0-9]{0,6}$/)
export const UltimaEntradaRegex = RegExp(/^[0-9]{0,6}.[0-9]{0,6}$/)
export const UltimaTransferenciaRegex = RegExp(/^[0-9]{0,6}.[0-9]{0,6}$/)
export const UltimoAjusteRegex = RegExp(/^[0-9]{0,6}.[0-9]{0,6}$/)